export default "__VITE_ASSET__e6W8NejX__ 1200w";